import React from 'react';
import { VerticalTimelineElement } from 'react-vertical-timeline-component/dist-es6';
import DoneIcon from '@material-ui/icons/Done';
import PhotoIcon from '@material-ui/icons/Photo';
import moment from 'moment';
import { name } from '../../../../utils/helper';

// const getIcon = (type) => {
//   switch (type) {
//     case 'photo':
//       return <PhotoIcon/>;
//     default:
//       return <DoneIcon/>;
//   }
// }
//
// const getHeading = (type, stage) => {
//   switch (type) {
//     case 'photo':
//       return 'Photo(s) uploaded';
//     default:
//       return `${stage.name} completed`;
//   }
// }

const PhotoUploadTimelineItem = ({ stage, by, date, photos }) => {
  // TODO use gravatar to icons - need to store email in audit logs
  return (<VerticalTimelineElement
    className="vertical-timeline-element--work"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<PhotoIcon/>}
  >
    <h3 className="vertical-timeline-element-title">{photos.length} photo{photos.length > 1 ? 's' : ''} uploaded</h3>
    <div><i>by <b>{name(by)}</b></i></div>
    {photos.map((photo) => <img key={photo} alt="Avatar" src="https://static.intercomassets.com/avatars/1416772/square_128/adam-horsman-headshot-1503509227-1528349044.jpg?1528349044"/>)}
    <div><i>approx. <b>{moment(date).format('lll')}</b></i></div>
  </VerticalTimelineElement>);
};

const StageCompletionTimelineItem = ({ stage, by, date }) => {
  return (<VerticalTimelineElement
    className="vertical-timeline-element--work"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<DoneIcon/>}
  >
    <h3 className="vertical-timeline-element-title">{stage.name} completed</h3>
    <div><i>by <b>{name(by)}</b></i></div>
    <div><i>at <b>{moment(date).format('lll')}</b></i></div>
  </VerticalTimelineElement>);
};

const TimelineItem = ({item: { type, stage, by, date, photos = [] }}) => {
  switch (type) {
    case 'photo':
      return <PhotoUploadTimelineItem stage={stage} by={by} date={date} photos={photos}/>
    default:
      return <StageCompletionTimelineItem stage={stage} by={by} date={date}/>;
  }
}

export default TimelineItem;



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/TaskTimeline/Item.js